<template>
    <div>
        <div class="lg:grid lg:grid-cols-10 lg:space-x-4">
            <div class="lg:col-span-2 px-6 py-4 bg-blue-50 mb-6">
                <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">{{ dataObj.interest.pay_interest }}</div>
                <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Pay Interest</div>
            </div>
            <div class="lg:col-span-2 px-6 py-4 bg-blue-50 mb-6">
                <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">{{ dataObj.interest.charge_interest }}</div>
                <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Charge Interest</div>
            </div>
            <div class="lg:col-span-2 px-6 py-4 mb-6">
            </div>
            <div class="lg:col-span-2 px-6 py-4 bg-blue-50 mb-6">
                <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">{{ dataObj.customer }}</div>
                <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Customer Number</div>
            </div>
            <div class="lg:col-span-2 px-6 py-4 bg-blue-50 mb-6">
                <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">{{ dataObj.month }}/{{ dataObj.year }}</div>
                <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Date</div>
            </div>
        </div>
        <div class="bg-white pt-2 shadow sm:rounded-md sm:overflow-hidden">
        <div class="px-4 sm:px-6 flex justify-between items-center">
            <h2 class="text-lg leading-6 font-medium text-gray-900 py-0">Monthly Activity</h2>
            <div class="flex">
                <div class="mr-4">
                    <label for="month" class="block text-xs font-medium text-gray-700">Month</label>
                    <select v-model="dateSelected.month" id="month" name="month" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
                        <option v-for="month in 12">{{ month }}</option>
                    </select>
                </div>
                <div class="">
                    <label for="year" class="block text-xs font-medium text-gray-700">Year</label>
                    <select v-model="dateSelected.year" id="year" name="year" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
                        <option v-for="year in years">{{ year }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="flex flex-col mt-6">
            <div class="-my-2 sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                            <tr>
                                <table-head display="Date" key-name="transaction_date" :sort-key="sortKey" :sort-order="sortOrder" />
                                <table-head display="Reference No." key-name="reference" :sort-key="sortKey" :sort-order="sortOrder"  />
                                <table-head display="Description" key-name="description" :sort-key="sortKey" :sort-order="sortOrder"  />
                                <table-head display="Amount" key-name="transaction_amount" :sort-key="sortKey" :sort-order="sortOrder"  />
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-if="dataObj.balanceForward !== 0">
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    </td>
                                    <td class="px-6 py-4 text-gray-500 text-sm">
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        Balance Forward
                                    </td>
                                    <td class="text-right px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        ${{ dataObj.balanceForward | currency }} <span v-if="dataObj.balanceForward < 0">CR</span>
                                    </td>

                                </tr>
                                <tr v-for="(item, idx) in sortedItems">
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {{ item.transaction_date | niceDate }}
                                    </td>
                                    <td class="px-6 py-4 text-gray-500 text-sm">
                                        {{ item.reference }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {{ item.description }}
                                    </td>
                                    <td class="text-right px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        ${{ item.transaction_amount | currency }} <span v-if="item.transaction_amount < 0">CR</span>
                                    </td>
                                </tr>
                                <tr v-if="items.length > 0" class="bg-blue-50 text-bold">
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                                    </td>
                                    <td class="px-6 py-4 text-gray-800 text-sm">
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                                        Total
                                    </td>
                                    <td class="text-right px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                                        ${{ statementTotal | currency }} <span v-if="statementTotal < 0">CR</span>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div v-if="items.length === 0" class="text-center text-gray-400 text-lg p-8">No current items...</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>


<script>

import TableHead from "@/Components/DataTable/TableHead";

export default {
    components: {TableHead},
    props: {
        dataObj: {
            type: Object,
            default: function () {
                return {
                    interest: {},
                    items: [],
                    month: new Date().getMonth() + 1,
                    year: new Date().getFullYear(),
                    customer: 0,
                    balanceForward: 0,
                }
            }
        },
    },
    data() {
        return {
            filteredItems: [],
            showFilter: false,
            sortKey: 'transaction_date',
            sortOrder: 'desc',
            searchOptions: {},
            items: this.dataObj.items,
            dateSelected: {
                month: this.dataObj.month,
                year: this.dataObj.year
            }
        }
    },
    mounted() {
        this.filteredItems = this.items
        this.$eventBus.$on('sortBy', (keyName) => {
            this.sortBy(keyName)
        })
    },
    methods: {
        setShowMenu(id) {
            this.showMenu = this.showMenu === id ? null : id
        },
        sortBy(key) {
            this.sortKey = key
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
        },
        compareValues(key, order = 'asc') {
            return function innerSort(a, b) {
                if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0;
                const comparison = a[key].toString().localeCompare(b[key], undefined, {numeric: true});
                return (
                    (order === 'desc') ? (comparison * -1) : comparison
                );
            };
        },
        currentDate() {
            let dateObj = new Date()
            let monthName = dateObj.toLocaleString("default", { month: "long" })
            let year = dateObj.getFullYear()
            return monthName + ' ' + year
        }
    },
    computed: {
        sortedItems() {
            return this.filteredItems.sort(
                this.compareValues(this.sortKey, this.sortOrder)
            )
        },
        years() {
            let years = []
            let startYear = 2021;
            while ( startYear <= new Date().getFullYear() ) {
                years.push(startYear++);
            }
            return years;
        },
        statementTotal() {
            return (Number(this.dataObj.balanceForward)) +
                this.dataObj.items.reduce((prev, cur) => prev + Number(cur.transaction_amount), 0);
        }
    },
    watch: {
        dateSelected: {
            deep: true,
            handler() {
                this.$inertia.get(this.route('monthly-statement', this.dateSelected))
            }
        },
        searchOptions: {
            deep: true,
            handler() {
                this.filteredItems = this.dataObj.items
                if (this.searchOptions.minTktNum) {
                    this.filteredItems = this.filteredItems.filter(item => item.load_ticket_number >= parseInt(this.searchOptions.minTktNum))
                }
                if (this.searchOptions.maxTktNum) {
                    this.filteredItems = this.filteredItems.filter(item => item.load_ticket_number <= parseInt(this.searchOptions.maxTktNum))
                }
                if (this.searchOptions.minTktDate) {
                    this.filteredItems = this.filteredItems.filter(item => new Date(item.load_ticket_date) >= new Date(this.searchOptions.minTktDate))
                }
                if (this.searchOptions.maxTktDate) {
                    this.filteredItems = this.filteredItems.filter(item => new Date(item.load_ticket_date) <= new Date(this.searchOptions.maxTktDate))
                }
            }
        }
    }
}
</script>
